import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

Breadcrumb.Item = BreadcrumbItem;

export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/breadcrumb/index.js
// module id = 338
// module chunks = 0